import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {allpayments} from "models/allpayments"; // Importing allpayments model
import {countries, devConfig, profile} from "config/config"; // Importing configuration settings

/**
 * Class representing a table view for managing partner credentials.
 * @extends JetView
 */
export default class tableView extends JetView {
    /**
     * Configures the layout of the table view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const id_partner = this.getParam("partner", true); // Get partner ID from parameters
        const vthis = this; // Reference to the current instance

        return {
            rows: [
                {
                    id: "preloader", // ID for the preloader
                    cols: [
                        {
                            view: "datatable", // Data table view
                            css: "webix_header_border webix_data_border webix_footer_border", // CSS classes for styling
                            id: "datatable", // ID for the data table
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [ // Column definitions for the data table
                                {
                                    id: "rating", header: "", width: 50, height: 25,
                                    template: function (obj) { // Template for the rating column
                                        if (devConfig.getPermAction("partnerEditCredential", "Edit")) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon if permission granted
                                        } else {
                                            return ""; // No icon if permission denied
                                        }
                                    }
                                },
                                {id: "Id", header: "Id", width: 50, sort: "int"}, // ID column
                                {id: "Provider", header: _("Proveedor"), fillspace:true, width: 200, sort: "int"}, // Provider column
                                {id: "SubProvider", header: _("Sub Proveedor"), width: 200, sort: "int"}, // Sub Provider column
                                {id: "Partner", header: _("Partner"), width: 150, sort: "int"}, // Partner column
                                {
                                    id: "State", header: _("Estado"), editor: "combo", options: [ // State column with combo editor
                                        {"id": "A", "value": _("Activado")},
                                        {"id": "I", "value": _("Inactivado")}
                                    ], width: 100, sort: "int"
                                },
                                {id: "Country", header: _("Pais"), css:"webix_win_title", width: 150, sort: "int"}, // Country column
                            ],
                            onClick: { // Event handler for click events
                                "edit": function (euv, id) { // Edit button click event
                                    $$("editform").clear(); // Clear the edit form
                                    var item = this.getItem(id); // Get the clicked item
                                    var newElements = [ // New elements for the edit form
                                        {
                                            id: "Id",
                                            view: "text",
                                            label: "Id",
                                            name: "Id",
                                            readonly: true,
                                            labelPosition: (screen.width < 500) ? "top" : "left", // Responsive label position
                                            labelWidth: 180
                                        },
                                        {
                                            view: "text",
                                            label: _("Proveedor"),
                                            name: "Provider",
                                            readonly: true,
                                            labelPosition: (screen.width < 500) ? "top" : "left",
                                            labelWidth: 180
                                        },
                                        {
                                            view: "text",
                                            label: _("Sub Proveedor"),
                                            name: "SubProvider",
                                            readonly: true,
                                            labelPosition: (screen.width < 500) ? "top" : "left",
                                            labelWidth: 180
                                        },
                                        {
                                            view: "text",
                                            label: _("Partner"),
                                            name: "Partner",
                                            readonly: true,
                                            labelPosition: (screen.width < 500) ? "top" : "left",
                                            labelWidth: 180
                                        },
                                        {
                                            view: "combo",
                                            label: _("Estado"),
                                            name: "State",
                                            readonly: true,
                                            options: [
                                                {"id": "A", "value": _("Activado")},
                                                {"id": "I", "value": _("Inactivado")}
                                            ],
                                            labelPosition: (screen.width < 500) ? "top" : "left",
                                            labelWidth: 180
                                        },
                                        {
                                            view: "text",
                                            label: _("País"),
                                            name: "Country",
                                            readonly: true,
                                            labelPosition: (screen.width < 500) ? "top" : "left",
                                            labelWidth: 180
                                        },
                                        { gravity: 0.01 }, // Spacer
                                        {
                                            view: "toolbar", // Toolbar for buttons
                                            height: 50,
                                            cols: [
                                                {
                                                    view: "button", value: _("Cancelar"), click: function () { // Cancel button
                                                        this.getTopParentView().hide(); // Hide the popup
                                                    }
                                                },
                                                {
                                                    view: "button", type: "form", value: _("Guardar"), click: function ($e) { // Save button
                                                        var values = $$("editform").getValues(); // Get form values
                                                        const credentialsString = values.Credentials; // Credentials string
                                                        const credentialsObject = JSON.parse(credentialsString); // Parse credentials to object
                                                        Object.keys(credentialsObject).forEach((credential) => { // Update credentials
                                                            Object.keys(values).forEach((data) => {
                                                                if(data == credential){
                                                                    credentialsObject[data] = values[data]; // Update credential value
                                                                }
                                                            })
                                                        })
                                                        var c2this = this; // Reference to the current button
                                                        let jsonData = JSON.stringify(credentialsObject); // Convert updated credentials to JSON
                                                        var credentialsBase64 = btoa(jsonData); // Encode credentials in Base64
                                                        webix.ajax().headers({ // AJAX request to update credentials
                                                            "Content-type": "application/json"
                                                        }).post(devConfig.geturlApi() + "PartnersCredentials/UpdatePartnerCredentials",
                                                            '{"Id":"' + values.Id + '","Credentials":' + JSON.stringify(credentialsBase64) + '}', {
                                                            error: function (text, data, XmlHttpRequest) { // Error handling
                                                                webix.message("Error! ");
                                                            },
                                                            success: function (text, data, XmlHttpRequest) { // Success handling
                                                                text = JSON.parse(text);
                                                                if (text.HasError) {
                                                                    webix.message("Error: " + text.AlertMessage); // Show error message
                                                                } else {
                                                                    $$("editform").clear(); // Clear the form
                                                                    c2this.getTopParentView().hide(); // Hide the popup
                                                                    webix.message("Sub Proveedor Partner Editado"); // Success message
                                                                    vthis.app.callEvent("refreshData", [{}]); // Refresh data event
                                                                }
                                                            }
                                                        });
                                                    }
                                                }
                                            ]
                                        }
                                    ];
                                    if(item.Credentials != undefined && item.Credentials != null && item.Credentials != ''){ // Check if credentials exist
                                        const credentialsString = item.Credentials; // Get credentials string
                                        const credentialsObject = JSON.parse(credentialsString); // Parse credentials to object
                                        Object.keys(credentialsObject).forEach((element) => { // Add credentials to new elements
                                            item[element] = credentialsObject[element];
                                            newElements.splice(6, 0 ,{
                                                id: element,
                                                view: "text",
                                                label: element,
                                                value: credentialsObject[element],
                                                name: element,
                                                disabled: false,
                                                labelPosition: (screen.width < 500) ? "top" : "left",
                                                labelWidth: 180
                                            })
                                        })
                                    }
                                    $$("editform").define('elements', newElements); // Define new elements in the form
                                    $$("editform").reconstruct(); // Reconstruct the form
                                    $$("editform").setValues(item); // Set values in the form
                                    $$("editCredentialsSubPartnerProducts").show(); // Show the edit popup
                                }
                            },
                            pager: "pagerA", // ID for the pager
                            loadahead: devConfig.getDefaultDataFetch(), // Preload data setting
                            url: devConfig.geturlApi() + "PartnersCredentials/GetPartnersCredentials?Partner=" + id_partner + "&" // Data source URL
                        }
                    ]
                },
                {
                    view:"pager", id:"pagerA", // Pager configuration
                    template:"{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}",
                    autosize:false,
                    height: 35,
                    size: 100 // Number of items per page
                },
            ]
        };
    }

    /**
     * Initializes the table view and sets up event handlers.
     * @param {Object} grid - The data table instance.
     */
    init(grid) {
        const _ = this.app.getService("locale")._; // Localization service
        grid = $$('datatable'); // Reference to the data table
        var url = grid.data.url; // Data source URL
        var cthis = this; // Reference to the current instance
        var popup = webix.ui({ // Popup configuration for editing credentials
            view: "window",
            id: "editCredentialsSubPartnerProducts",
            width: 650,
            height: 450,
            fullscreen: (screen.width < 500) ? true : false, // Responsive design
            head: {
                view: "toolbar",
                cols: [
                    {view: "label", label: _("Editar Partner")}, // Label for the popup
                    {
                        view: "icon", icon: "wxi-close", click: function () { // Close button
                            this.getTopParentView().hide(); // Hide the popup
                        }
                    }
                ]
            },
            position: "center", // Center the popup
            modal: true,
            body: {
                view: "scrollview",
                scroll: "y",
                body: {
                    view: "form",
                    id: "editform", // ID for the edit form
                    elements: [] // Elements will be defined dynamically
                }
            }
        });
        var filter = ""; // Filter string for data loading
        var varTemp = ""; // Temporary variable for filter data
        this.on(this.app, "refreshData", filterData => { // Event handler for refreshing data
            this.app.callEvent("partnerCredentialsSubProvider:filter", [varTemp]); // Call filter event
        });
        this.on(this.app, "partnerCredentialsSubProvider:filter", filterData => { // Event handler for filtering data
            var object = Object.entries(filterData); // Convert filter data to entries
            varTemp = filterData; // Store filter data
            var string1 = ""; // Initialize filter string
            for (var i = 0; i < object.length; i++) { // Iterate through filter data
                if ((typeof object[i][1] !== "object") && (object[i][1] !== "")) { // Check for non-object values
                    if (object[i][0] == "Datepicker") { // Handle date range filter
                        var date = object[i][1].split(" - ");
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if ((typeof object[i][1] === "object")) { // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) { // Iterate through object entries
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === "start") { // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom = "dateFrom=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter string
                                } else {
                                    if (object2[j][0] === "end") { // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo = "dateTo=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the grid data
            grid.load(url + '?start=0&count=1000' +  grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });
        grid.attachEvent("onAfterSort", function (by, dir, as) { // Event handler for sorting
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });
        grid.attachEvent("onItemClick", function (id, e, node) { // Event handler for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent("user:id", [item.Id]); // Call user ID event
        });
        this.on(this.app, "player:select", Id => { // Event handler for player selection
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id); // Load data for selected player
        });
        grid.attachEvent("onItemDblClick", function (id, e, node) { // Event handler for item double click
            if (devConfig.getPermAction("partnerEditCredential", "Edit")) { // Check edit permission
                popup.show(); // Show the edit popup
            } else {
                return ""; // Do nothing if no permission
            }
        });
        $$("editform").bind($$("datatable")); // Bind the edit form to the data table
    }
}

// FILE DOCUMENTED
